import React, { createRef } from 'react';
import PropTypes from 'prop-types';


class Tabs extends React.Component {
  containerReference = createRef();

  state = {
    activeTab: this.props.initialActiveTab,
    activeTabOffsetLeft: 0
  };

  componentDidMount() {
    this.adjustUnderline(this.state.activeTab);
  }

  childrenReferences = new Map();

  createTab = (tab) => {
    const { adjustUnderline } = this;
    const { activeTab } = this.state;
    const { customTabClasses } = this.props;
    const { id } = tab.props;

    const newTabProperties = {
      active: id === activeTab,
      customClasses: customTabClasses,
      adjustUnderline: () => adjustUnderline(id),
      key: `tab-${id}`,
      ref: (reference) => this.childrenReferences.set(id, reference)
    };

    return React.cloneElement(tab, newTabProperties);
  };

  adjustUnderline = (id) => {
    const { containerReference, childrenReferences } = this;

    const activeTabReference = childrenReferences.get(id).reference.current;
    const activeTabOffsetLeft = activeTabReference.offsetLeft;

    containerReference.current.scrollLeft = activeTabOffsetLeft;
    this.setState({ activeTabOffsetLeft, activeTab: id });
  };

  render() {
    const { createTab, childrenReferences, containerReference } = this;
    const { activeTab, activeTabOffsetLeft } = this.state;
    const { children, customClasses } = this.props;

    const { customClass, customBorder, customUnderline, customWrapper } = customClasses;

    return (
      <div className={ customWrapper } ref={ containerReference } data-test="section-tabs">

        <div className={ customClass }>

          {
            children.map(createTab)
          }

          <span className={ customBorder }/>

          {childrenReferences.size > 0 &&
          <span className={ customUnderline }
                style={ {
                  left: 0,
                  transform: `translateX(${activeTabOffsetLeft}px)`,
                  width: childrenReferences.get(activeTab).reference.current.offsetWidth
                } }
          />
          }

        </div>

      </div>
    );
  }
}


Tabs.propTypes = {
  initialActiveTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  customClasses: PropTypes.shape({
    customTabs: PropTypes.string,
    customWrapper: PropTypes.string,
    customBorder: PropTypes.string,
    customUnderline: PropTypes.string
  }),
  customTabClasses: PropTypes.shape({
    customClass: PropTypes.string,
    customActiveClass: PropTypes.string
  }),
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

Tabs.defaultProps = {
  customClasses: {
    customTabs: '',
    customBorder: '',
    customUnderline: '',
    customWrapper: ''
  },
  customTabClasses: {
    customClass: '',
    customActiveClass: ''
  }
};


export default Tabs;
